import * as angular from 'angular';

export class LngOffersService {
    public offerDeletedSuccessfully: boolean = false;
}

angular.module('app').service('lngOffersService', LngOffersService);
